import { render, staticRenderFns } from "./DetailsLieferung.vue?vue&type=template&id=22bc2460&scoped=true"
import script from "./DetailsLieferung.vue?vue&type=script&lang=ts"
export * from "./DetailsLieferung.vue?vue&type=script&lang=ts"
import style0 from "./DetailsLieferung.vue?vue&type=style&index=0&id=22bc2460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bc2460",
  null
  
)

export default component.exports